import Grid from "@mui/material/Grid2";
import { useFieldArray, useForm } from "react-hook-form";
import { useEffect, useMemo, useState } from "react";

import { TabSessionDataReAuthResponse } from "../../../models/api/TabSessionStorage";
import {
  defaultReAuthTabData,
  ReAuthTabData,
} from "../../../models/TabSessionStorage";
import { MemberInfoData, PatientInformation } from "../../../models/Patient";
import { getValue } from "../../../utils";
import { Numbers } from "../../../constants/Referral";
import { MyAccountModel } from "../../../models/MyAccount";
import { formatDate } from "../../../utils/DateTime";
import { DateFormats } from "../../../constants/Date";
import ReAuthTabs from "../containers/ReAuthTabs";
import { rules } from "../../../utils/validation/Validation";
import PatientInfo from "../../PatientInfoHeader/PatientInfo";
import { mainContentStyle, overFlowAuto } from "../../PriorAuthWorkFlow/styles/style";

export interface PropsFromState {
  tabSessionStorage: TabSessionDataReAuthResponse;
  memberInfoDataState: MemberInfoData | undefined;
  patientInformationByIdState: PatientInformation;
  loggedInUserState: MyAccountModel;
}
export interface PropsFromDispatch {
  saveTabSessionStorage: (sessionData: ReAuthTabData) => void;
}

type AllProps = PropsFromState & PropsFromDispatch;

const ReAuthorizationForm: React.FC<AllProps> = ({
  saveTabSessionStorage,
  tabSessionStorage,
  memberInfoDataState,
  loggedInUserState,
}: AllProps) => {
  const [currentTab, setCurrentTab] = useState(0);
  const [formError, setFormError] = useState<any>();
  const [fileUpload, setFileUpload] = useState<File[]>([]);
  const [reimbursementTypeId, setReimbursementTypeId] = useState<number>(
    Numbers.ZERO
  );
  const methods = useForm<ReAuthTabData>({
    defaultValues: defaultReAuthTabData,
    mode: "all",
    criteriaMode: "all", // Ensures all validation errors are collected
  });

  const {
    reset,
    getValues,
    control,
    setValue,
    clearErrors,
    watch,
    handleSubmit,
    trigger,
    formState,
  } = methods;
  const { errors } = formState;

  useEffect(() => {
    setFormError(tabSessionStorage);
  }, [tabSessionStorage]);

  const saveDetails = (data: any) => {
    const payloadData = {
      ...data,
      icdCodesDetails: {
        ...data.icdCodesDetails,
        icdCodesInfoDto: data.diagnosisCode,
        fullNameCreated: getValue(
          loggedInUserState,
          "providerPortalUser.email"
        ),
        typeId: 2,
      },
      requestService: {
        ...data.requestService,
        startOfCare: formatDate(
          getValue(data, "requestService.startOfCare"),
          DateFormats.YYYY_MM_DD
        ),
      },
    };
    SubmitForm(payloadData);
  };
  const SubmitForm = (data: ReAuthTabData) => {
    if (Object.keys(data).length !== 0) {
      saveTabSessionStorage(data);
    }
  };

  const {
    fields: icd10RecordsFields,
    append: icd10RecordsAppend,
    remove: icd10RecordsRemove,
  } = useFieldArray({
    control,
    name: "diagnosisCode",
    rules: useMemo(() => {
      return currentTab === 2 ? rules.icdCodes : { required: false };
    }, [currentTab]),
  });

  const values = getValues();

  const submitDetails = () => {
    handleSubmit(
      (data) => {
        saveDetails({
          ...data,
          referralId: memberInfoDataState?.referralId ?? "",
        });
      },
      (formErrors) => {
        setFormError(formErrors);
      }
    )();
  };
  return (
    <>
      <Grid container direction="column" sx={mainContentStyle}>
        <Grid sx={overFlowAuto}>
          <PatientInfo
            watch={watch}
            memberInfoDataState={memberInfoDataState}
            label={"RE-AUTHORIZATION FORM"}
            type={2}
          />
          <ReAuthTabs
            setCurrentTab={setCurrentTab}
            saveTabSessionStorage={saveTabSessionStorage}
            tabSessionStorage={tabSessionStorage}
            currentTab={currentTab}
            watch={watch}
            getValues={getValues}
            reset={reset}
            setValue={setValue}
            control={control}
            clearErrors={clearErrors}
            formError={formError}
            trigger={trigger}
            values={values}
            formState={formState}
            handleSubmit={submitDetails}
            setFileUpload={setFileUpload}
            fileUpload={fileUpload}
            errors={errors}
            setReimbursementTypeId={setReimbursementTypeId}
            reimbursementTypeId={reimbursementTypeId}
            icd10RecordsFields={icd10RecordsFields}
            icd10RecordsAppend={icd10RecordsAppend}
            icd10RecordsRemove={icd10RecordsRemove}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default ReAuthorizationForm;
